<template src="./UserBadge.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import { Routes } from "@/router/routes";
import { accountModule } from "@/store/modules/account";
import { AccountActions } from "@/store/modules/account/actions";
import { AccountGetters } from "@/store/modules/account/getters";
import { Session } from "@/models/Session";

type MenuItem = {
    name: string;
    href?: string;
    action?: (() => void) | (() => Promise<void>);
};

export default defineComponent({
    computed: {
        ...accountModule.mapGetters({
            session: AccountGetters.Session
        }),
        fullname(): string {
            const session = this.session as Session | null;
            if (!session) return "";
            const { firstName, lastName } = session.User;
            return `${firstName} ${lastName}`;
        }
    },
    methods: {
        ...accountModule.mapActions({
            logUserOut: AccountActions.LogUserOut
        }),
        async logout(): Promise<void> {
            await this.logUserOut();
            this.$router.push(Routes.Login);
        }
    },
    data() {
        return {
            infoMenuItems: [
                {
                    href: "/manuals/IFM_FIRST_STEPS_EN.pdf",
                    name: "First Steps EN"
                },
                {
                    href: "/manuals/IFM_FIRST_STEPS_DE.pdf",
                    name: "First Steps DE"
                },
                {
                    href: "/manuals/2023_01_30_IFM_USER_GUIDE_EN.pdf",
                    name: "User Manual EN"
                },
                {
                    href: "/manuals/2023_01_30_IFM_USER_GUIDE_DE.pdf",
                    name: "User Manual DE"
                }
            ] as MenuItem[],
            accountMenuItems: [
                { name: "Log out", action: undefined }
            ] as MenuItem[],
            isAccountMenuVisible: false,
            isInfoMenuVisible: false
        };
    },
    created() {
        this.accountMenuItems[0].action = this.logout;
    }
});
</script>

<style lang="scss" scoped></style>
